module.exports = __webpack_public_path__ + "static/about-insta-7@2x-401739c169968372f63c6230d8238fc9.jpg";